import React, { useState } from 'react';
import projectsData from './data/projects_data.js';

export default function Projects() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Function to handle category filter
  const handleFilter = (category) => {
    setSelectedCategory(category);
  };

  // Filter projects based on selected category
  const filteredProjects = selectedCategory
    ? projectsData.filter(project => project.category === selectedCategory)
    : projectsData;

  return (
    <section className="content" id='Projects'>
      <h2>Projects</h2>
      <div className="filter data-trigger">
        <a href="#Projects" onClick={() => handleFilter(null)}>All</a>
        <a href="#Projects" onClick={() => handleFilter("Data Analytics")}>Data Analytics</a>
        <a href="#Projects" onClick={() => handleFilter("Data Science with Machine Learning")}>Data Science with Machine Learning</a>
        <a href="#Projects" onClick={() => handleFilter("Web Development")}>Web Development</a>
      </div>
      
      <div className='project'>
        {filteredProjects.map(project => (
          <div key={project.title}>
            <div className='project-title'>
              <h3>{project.title}</h3>
              <p>{project.date}</p>
            </div>

            <p className='lead'>Field: {project.category}</p>
            <p>Work Done:</p>
            
            {project.content.split('*').map((item, index) => (
                <p key={index}>{item.trim()}</p> 
            ))}
            <a className='btn' href={project.github}>View project on GitHub</a>
          </div>
        ))}
      </div>
    </section>
  );
}
